<template>
  <v-dialog v-model="dialog" max-width="650px">
    <template v-slot:activator="{ on }">
      <v-btn style="margin: 0" color="secondary" v-on="on" block> Regístrate vía email </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <span class="headline"> Regístrate vía email </span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col class="pt-0 pb-0">
              <v-text-field v-model="user.nombre" label="Nombre" :rules="name_rules" required />
            </v-col>
            <v-col class="pt-0 pb-0">
              <v-text-field v-model="user.apellidos" label="Apellidos" :rules="name_rules" required="" />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0 pb-0">
              <v-text-field v-model="user.email" label="Email" :rules="email_rules" required />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0 pb-0">
              <v-text-field v-model="user.password" label="Password" :rules="password_rules" type="password" required />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0 pb-0">
              <v-text-field v-model="user.telefono" label="Teléfono" :rules="phone_rules" required />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0 pb-0">
              <v-select
                  v-model="user.ciudad"
                  :items="cities_items"
                  item-text="nombre"
                  item-value="id"
                  label="Ciudad"
                  :rules="ciudad_rules"
                  required
              />
            </v-col>

            <v-col class="pt-0 pb-0">
              <v-select
                  v-model="user.sexo"
                  :items="sexos_items"
                  item-text="text"
                  item-value="value"
                  label="Sexo"
                  :rules="sexo_rules"
                  required
              />
            </v-col>
          </v-row>
        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!valid" text @click="register">Registrarse</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  name: 'Registro',
  data(){
    return {
      dialog: false,
      valid: false,
      user: {
        nombre: "",
        apellidos: "",
        email: "",
        password: "",
        telefono: "",
        ciudad: null,
        sexo: null,
        origen: 'w'
      },

      cities_items: [{"id":653,"country_id":"67","nombre":"Álava","slug":"alava","activoPortal":"0","latitud":"42,84641","longitud":"-2,667893"}, {"id":654,"country_id":"67","nombre":"Albacete","slug":"albacete","activoPortal":"0","latitud":"38,99765","longitud":"-1,86007"}, {"id":655,"country_id":"67","nombre":"Alicante","slug":"alicante","activoPortal":"0","latitud":"38,3452","longitud":"-0,481006"}, {"id":656,"country_id":"67","nombre":"Almería","slug":"almeria","activoPortal":"0","latitud":"36,84016","longitud":"-2,467922"}, {"id":657,"country_id":"67","nombre":"Ávila","slug":"avila","activoPortal":"0","latitud":"40,65642","longitud":"-4,700323"}, {"id":658,"country_id":"67","nombre":"Badajoz","slug":"badajoz","activoPortal":"0","latitud":"38,8786","longitud":"-6,970284"}, {"id":659,"country_id":"67","nombre":"Baleares (Illes)","slug":"baleares-illes","activoPortal":"0","latitud":"39,56951","longitud":"2,649966"}, {"id":660,"country_id":"67","nombre":"Barcelona","slug":"barcelona","activoPortal":"1","latitud":"41,38792","longitud":"2,169919","outstanding":"1"}, {"id":661,"country_id":"67","nombre":"Burgos","slug":"burgos","activoPortal":"0","latitud":"42,34087","longitud":"-3,699731"}, {"id":662,"country_id":"67","nombre":"Cáceres","slug":"caceres","activoPortal":"0","latitud":"39,47618","longitud":"-6,37076"}, {"id":663,"country_id":"67","nombre":"Cádiz","slug":"cadiz","activoPortal":"0","latitud":"36,52969","longitud":"-6,292657"}, {"id":664,"country_id":"67","nombre":"Castellón","slug":"castellon","activoPortal":"0","latitud":"39,98598","longitud":"-0,0376709"}, {"id":665,"country_id":"67","nombre":"Ciudad Real","slug":"ciudad-real","activoPortal":"0","latitud":"38,9861","longitud":"-3,927263"}, {"id":666,"country_id":"67","nombre":"Córdoba","slug":"cordoba","activoPortal":"0","latitud":"37,88473","longitud":"-4,779152"}, {"id":667,"country_id":"67","nombre":"A Coruña","slug":"a-coruna","activoPortal":"0","latitud":"43,37087","longitud":"-8,395835"}, {"id":668,"country_id":"67","nombre":"Cuenca","slug":"cuenca","activoPortal":"0","latitud":"40,07183","longitud":"-2,134005"}, {"id":669,"country_id":"67","nombre":"Girona","slug":"girona","activoPortal":"0","latitud":"41,9818","longitud":"2,8237"}, {"id":670,"country_id":"67","nombre":"Granada","slug":"granada","activoPortal":"0","latitud":"37,17649","longitud":"-3,597929"}, {"id":671,"country_id":"67","nombre":"Guadalajara","slug":"guadalajara","activoPortal":"0","latitud":"40,62981","longitud":"-3,166493"}, {"id":672,"country_id":"67","nombre":"Guipúzcoa","slug":"guipuzcoa","activoPortal":"0","latitud":"43,32074","longitud":"-1,984421"}, {"id":673,"country_id":"67","nombre":"Huelva","slug":"huelva","activoPortal":"0","latitud":"37,2571","longitud":"-6,949555"}, {"id":674,"country_id":"67","nombre":"Huesca","slug":"huesca","activoPortal":"0","latitud":"42,1401","longitud":"-0,408898"}, {"id":675,"country_id":"67","nombre":"Jaén","slug":"jaen","activoPortal":"0","latitud":"37,76574","longitud":"-3,789518"}, {"id":676,"country_id":"67","nombre":"León","slug":"leon","activoPortal":"0","latitud":"42,59988","longitud":"-5,571752"}, {"id":677,"country_id":"67","nombre":"Lleida","slug":"lleida","activoPortal":"0","latitud":"41,61415","longitud":"0,6257825"}, {"id":678,"country_id":"67","nombre":"La Rioja","slug":"la-rioja","activoPortal":"0","latitud":"42,46577","longitud":"-2,449995"}, {"id":679,"country_id":"67","nombre":"Lugo","slug":"lugo","activoPortal":"0","latitud":"43,01208","longitud":"-7,555851"}, {"id":680,"country_id":"67","nombre":"Madrid","slug":"madrid","activoPortal":"1","latitud":"40,41669","longitud":"-3,700346","outstanding":"1"}, {"id":681,"country_id":"67","nombre":"Málaga","slug":"malaga","activoPortal":"0","latitud":"36,71965","longitud":"-4,420019"}, {"id":682,"country_id":"67","nombre":"Murcia","slug":"murcia","activoPortal":"0","latitud":"37,98344","longitud":"-1,12989"}, {"id":683,"country_id":"67","nombre":"Navarra","slug":"navarra","activoPortal":"0","latitud":"42,81721","longitud":"-1,646767"}, {"id":684,"country_id":"67","nombre":"Ourense","slug":"ourense","activoPortal":"0","latitud":"42,34001","longitud":"-7,864641"}, {"id":685,"country_id":"67","nombre":"Asturias","slug":"asturias","activoPortal":"0","latitud":"43,36026","longitud":"-5,844759"}, {"id":686,"country_id":"67","nombre":"Palencia","slug":"palencia","activoPortal":"0","latitud":"42,01246","longitud":"-4,531175"}, {"id":687,"country_id":"67","nombre":"Las Palmas","slug":"las-palmas","activoPortal":"0","latitud":"28,12482","longitud":"-15,43001"}, {"id":688,"country_id":"67","nombre":"Pontevedra","slug":"pontevedra","activoPortal":"0","latitud":"42,43362","longitud":"-8,648053"}, {"id":689,"country_id":"67","nombre":"Salamanca","slug":"salamanca","activoPortal":"0","latitud":"40,96497","longitud":"-5,663047"}, {"id":690,"country_id":"67","nombre":"Santa Cruz de Tenerife","slug":"santa-cruz-de-tenerife","activoPortal":"0","latitud":"28,46981","longitud":"-16,25486"}, {"id":691,"country_id":"67","nombre":"Cantabria","slug":"cantabria","activoPortal":"0","latitud":"43,46096","longitud":"-3,807934"}, {"id":692,"country_id":"67","nombre":"Segovia","slug":"segovia","activoPortal":"0","latitud":"40,94943","longitud":"-4,119209"}, {"id":693,"country_id":"67","nombre":"Sevilla","slug":"sevilla","activoPortal":"0","latitud":"37,38264","longitud":"-5,996295"}, {"id":694,"country_id":"67","nombre":"Soria","slug":"soria","activoPortal":"0","latitud":"41,7636","longitud":"-2,464921"}, {"id":695,"country_id":"67","nombre":"Tarragona","slug":"tarragona","activoPortal":"0","latitud":"41,11866","longitud":"1,24533"}, {"id":696,"country_id":"67","nombre":"Teruel","slug":"teruel","activoPortal":"0","latitud":"40,34411","longitud":"-1,10691"}, {"id":697,"country_id":"67","nombre":"Toledo","slug":"toledo-spain","activoPortal":"0","latitud":"39,85678","longitud":"-4,024476"}, {"id":698,"country_id":"67","nombre":"Valencia","slug":"valencia","activoPortal":"1","latitud":"39,47024","longitud":"-0,3768049"}, {"id":699,"country_id":"67","nombre":"Valladolid","slug":"valladolid","activoPortal":"0","latitud":"41,65295","longitud":"-4,728388"}, {"id":700,"country_id":"67","nombre":"Vizcaya","slug":"vizcaya","activoPortal":"0","latitud":"43,25696","longitud":"-2,923441"}, {"id":701,"country_id":"67","nombre":"Zamora","slug":"zamora","activoPortal":"0","latitud":"41,50368","longitud":"-5,743778"}, {"id":702,"country_id":"67","nombre":"Zaragoza","slug":"zaragoza","activoPortal":"0","latitud":"41,65629","longitud":"-0,8765379"}, {"id":703,"country_id":"67","nombre":"Ceuta","slug":"ceuta","activoPortal":"0","latitud":"35,88829","longitud":"-5,316195"}, {"id":704,"country_id":"67","nombre":"Melilla","slug":"melilla","activoPortal":"0","latitud":"35,29234","longitud":"-2,938794"}],
      sexos_items: [
        { value: 'f', text: 'Mujer' },
        { value: 'm', text: 'Hombre' }
      ],

      name_rules: [
        v => !!v || 'El nombre es obligatorio',
        v => v.length >= 3 || 'El nombre debe tener al menos 3 caracteres'
      ],
      email_rules: [
        v => !!v || 'El email es obligatorio',
        v => /.+@.+/.test(v) || 'El email debe ser válido'
      ],
      password_rules: [
        v => !!v || 'El password es obligatorio',
        v => (v && v.length >= 6) || 'El password debe tener al menos 6 caracteres'
      ],
      phone_rules: [
        phone => !!phone || 'El teléfono es obligatorio',
        phone => phone.length >= 9 || 'El número de móvil debe tener al menos 9 dígitos',
        phone => !isNaN(phone) || 'El número de móvil debe tener solo cifras'
      ],
      ciudad_rules: [
        v => !!v || 'La ciudad es obligatoria'
      ],
      sexo_rules: [
        v => !!v || 'El sexo es obligatorio'
      ]
    }
  },

  methods: {
    async register() {
      if(this.$refs.form.validate()){
        const user = await this.$store.dispatch('auth/register', this.user)
        if(user){
          this.$notify({
            title: 'Acción realizada correctamente',
            text: `Te hemos enviado un email a ${user.email} y un SMS al número ${user.telefono} para que puedas activar tu cuenta. Revisa tu carpeta de correo no deseado.`,
          })
          this.dialog = false
          this.$emit('on_registro')
        }
      }
    }
  },

  mounted() {
    if(this.centro){
      this.user.ciudad = this.centro.city.id
    }
  },

  computed: {
    centro(){
      return this.$store.state.centro.centro
    }
  }
}
</script>
